import React from "react";
import InputComponent from "shared/ui/common/InputComponent";
import {PropertyRowComponent} from "../../../../../editor/ui/experience/widgets/toolbox/PropertiesView";
import {PropertyContainerComponent} from "../../../../../editor/ui/experience/widgets/toolbox/PropertyContainerComponent";

interface AnalyticsPropertiesViewProps {
    onChange: (value: string) => void;
    emailModeEnabled: boolean;
    labelValue: string;
}

export default function AnalyticsPropertiesView({labelValue, onChange, emailModeEnabled}: AnalyticsPropertiesViewProps) {

    const handleChange = (event) => {
        event.preventDefault();
        onChange(event.target.value);
    };

    const tippyMessage = "Enter your label here to help decipher your data within Google Analytics. If it’s a product, add the SKU or if it’s a URL add the page title.";
    return (
        <div>   
            <PropertyContainerComponent
                widgetSelected={true}
                label={"Analytics"}
                name={"analytics"}
                animateExpandOnMount={false}
                isEnabled={!emailModeEnabled} 
            >   
                <PropertyRowComponent 
                    name={"event-label"} 
                    label={"Custom Event Label"} 
                    tip={tippyMessage} 
                    isColStretched={true}
                >
                    <InputComponent
                        classNames="full-width"
                        type="text"
                        value={labelValue}
                        onChange={handleChange}
                        placeholder="Enter your label here&#8230;"
                    />
                </PropertyRowComponent>
            </PropertyContainerComponent>
        </div> 
    );
}


// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/analytics/AnalyticsPropertiesView.tsx